<template>
  <div class="added-date">
    <span>{{ label }}</span>
  </div>
</template>

<script>
export default {
  name: 'AddedDaysAgo',
  props: {
    label: {
      type: String,
      required: true,
    },
  },
}
</script>
<style scoped lang="scss">
.added-date {
  display: flex;
  background: var(--secondary-promo-purple);
  box-shadow: var(--purple-light-box-shadow);
  align-items: center;
  justify-content: center;
  border-radius: 0 10px 0 10px;
  padding: 4px 9px;

  @include mobile {
    padding: 5px 20px;
  }

  span {
    font-family: var(--font-book);
    font-weight: 450;
    font-size: rem(10px);
    line-height: rem(12px);
    @include mobile {
      font-size: rem(12px);
      line-height: rem(14px);
    }
  }
}
</style>
